import { truncate } from "../utils/truncate";
export function createExcerpt(content) {
    if (content) {
        var contentNoImages = content.replace(/<img[^>]*>/g, "");
        var contentTruncated = truncate(contentNoImages, 25);
        return contentTruncated;
    }
    return null;
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/utils/createExcerpt.tsx
// module id = E8nV
// module chunks = 3